<script lang="ts">
	import { t } from 'svelte-i18n'
	import type { Lever } from '@semanticedge/persistence-service-noheaders-client/src'
	import { Modal } from '@repo/commons/components'
	import type { ProjectViewModel, TableData } from '@repo/commons/models'
	import SetLeverValueForm from './SetLeverValueForm.svelte'

	type Props = {
		visible: boolean
		onclose: VoidFunction
		project: ProjectViewModel | null
		editingLever?: TableData | null
		existingLeverIds: readonly string[]
		onSubmit: (lever: Partial<Lever>, isEdit: boolean) => Promise<boolean>
	}

	const { visible, onclose, ...formProps }: Props = $props()
</script>

<Modal
	{visible}
	{onclose}
	showCloseButton={false}
	closeOnBackdropClick={false}
	title={$t('SetLeverValueModal.title')}
>
	<SetLeverValueForm {onclose} {...formProps} />
</Modal>
